<template>
  <div class="listagem-status">
    <div v-if="emptyMessage && listagemData.length === 0"
         style="background: #F6F6F6 0 0 no-repeat padding-box;
           border-radius: 6px; padding: 18px;"
         slot="append">
      <div
        style="font: normal normal normal 14px/16px SF Pro Text; letter-spacing: 0; color: #000000; opacity: 0.5;"
      >
        {{emptyMessage}}
      </div>
    </div>
    <el-table
      v-else
      :cell-style="applyRowColor"
      :data="listagemData"
      :row-class-name="'status-row'"
      style="width: 100%"
      :class="{'no-hover': noHover }"
      empty-message=""
    >
      <el-table-column
        v-for="(column, index) in columns"
        :width="column.width"
        :key="index"
        :label="column.header ? column.header.label : null"
        :sortable="!!(column.header && column.header.sortable)"
        :class-name="column.noPadding ? 'no-padding' : ''"
      >
        <template slot-scope="scope">
          <template v-if="Array.isArray(column)">
            <template v-for="(col, index) in column">
              <template v-if="col.component && showComponent(col)">
                <component
                  :is="col.component"
                  :column="col"
                  :row="scope.row"
                  :key="index"
                  @click="clickRow(scope.row)"
                />
              </template>
              <template
                v-if="!col.component && showComponent(col)"
                :class-name="`item-${col.field}`"
                @click="clickRow(scope.row)"
              >
                {{ scope.row[col.field] || '-' }}
              </template>
            </template>
          </template>
          <template v-else>
            <template v-if="column.component && showComponent(column)">
              <component
                :is="column.component"
                :column="column"
                :row="scope.row"
                @click="clickRow(scope.row)"
              />
            </template>
            <template
              v-if="!column.component && showComponent(column)"
              :class-name="`item-${column.field}`"
              @click="clickRow(scope.row)"
            >
              {{ scope.row[column.field] || '-' }}
            </template>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'ListagemStatus',
  props: {
    columns: {
      type: Array,
      required: true
    },
    listagemData: {
      type: Array,
      required: true
    },
    emptyMessage: {
      type: String
    },
    statusField: {
      type: String
    },
    clickRow: {
      type: Function,
      default: (row) => {
      }
    },
    noHover: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    applyRowColor ({ row }) {
      const rowElement = row[this.statusField]
      if (!rowElement) {
        return {}
      }
      return {
        'border-color': `${rowElement.cor}`
      }
    },
    showComponent (col) {
      return col.showColumn === undefined ? true : col.showColumn
    }
  }
}
</script>
<style lang="less">
  .listagem-status {
    .no-padding {
      padding: 0 !important
    }
  }
</style>
